import { EntityDto, IEntityDto } from "../../../utils/models/entity-dto";
import { FieldType } from "@gbs-platform-client/fwk-core";
import { Users } from "./users";
import { EmployeeSecretary } from "./employeesecretary";

export class Employee extends EntityDto implements IEntityDto {
    Emp_Ref_Id: string;
    EmployeeName: string;
    UserName: string;
    EmployeeCode: string;
    Salutation:string;
    Location_Id:String;
    Phone: string;
    EmailId: string;
    Company_Id: string;
    CompanyName: string;
    Division_Id: string;
    DivisionName: string;
    Salutation_Id: string;
    LocationName: string;
    Department_Id: string;
    DepartmentName: string;
    SubDepartment_Id: string;
    SubDepartmentName: string;
    Unit_Id: string;
    UnitName: string;
    Designation_Id: string;
    DesignationName: string;
    Position_Id:string;
    PositionName:string;
    TotalCount: number;
    IsActive: boolean;
    IsHOStaff:boolean;

    Document: any;
    Document_Name: string;
    FileName: string;
    Ref_Id: string | null;
    CommitteeOrg_Id:string;
    User_Id:string
    PrivateCommentsTo :Array<Users>;
    Secretary:Array<EmployeeSecretary>;
    secretaryName:string;
    Secretary_Emp_Ref_Id:string;
    constructor() {
        super();
        this.Emp_Ref_Id = "00000000-0000-0000-0000-000000000000";
        this.EmployeeName = "";
        this.EmployeeCode = "";
        this.Salutation="";
        this.EmailId = "";
        this.Company_Id = "";
        this.CompanyName = "";
        this.Division_Id = "";
        this.DivisionName = "";
        this.Location_Id = "";
        this.Salutation_Id="";
        this.LocationName = "";
        this.Department_Id = "";
        this.DepartmentName = "";
        this.SubDepartment_Id = "";
        this.SubDepartmentName = "";
        this.Unit_Id = "";
        this.UnitName = "";
        this.Designation_Id = "";
        this.DesignationName = "";
        this.Position_Id="";
        this.PositionName="";
        this.TotalCount = 0;
        this.Phone = "";
        this.IsActive = true;
        this.IsHOStaff = false;
        this.Document = null;
        this.Document_Name = "";
        this.FileName = "";
        this.Ref_Id = "";
        this.UserName="";
        this.CommitteeOrg_Id="00000000-0000-0000-0000-000000000000";
        this.User_Id="00000000-0000-0000-0000-000000000000";
        this.PrivateCommentsTo=[];
        this.Secretary=[];
        this.secretaryName="";
        this.Secretary_Emp_Ref_Id="00000000-0000-0000-0000-000000000000";

        this.EntityMetaData = [
            { FieldName: 'EmployeeCode', FieldType: FieldType.String, IsMandatory: true, ValidationMessage: 'Employee Code is required' },
            { FieldName: 'EmployeeName', FieldType: FieldType.String, IsMandatory: true, ValidationMessage: 'Employee Name is required' },
             { FieldName: 'Department_Id', FieldType: FieldType.String, IsMandatory: true, ValidationMessage: 'Department is required' },      
            // { FieldName: 'Phone', FieldType: FieldType.String, IsMandatory: true, ValidationMessage: 'Phone is required' },
            { FieldName: 'EmailId', FieldType: FieldType.String, IsMandatory: true, ValidationMessage: 'Email is required' },
            { FieldName: 'Designation_Id', FieldType: FieldType.String, IsMandatory: true, ValidationMessage: 'Designation is required' },
            { FieldName: 'Location_Id', FieldType: FieldType.String, IsMandatory: true, ValidationMessage: 'Branch is required' },
            { FieldName: 'Salutation_Id', FieldType: FieldType.String, IsMandatory: true, ValidationMessage: 'Salutation is required' },
            // { FieldName: 'secretaryName', FieldType: FieldType.String, IsMandatory: true, ValidationMessage: 'Secretary Name is required' },

          
        ];
    }
}
